import React from 'react';
import { Box, Flex, FormField, InfoButton, ToggleTooltip, Text } from '@indeed/ifl-components';
import { Information } from '@indeed/ifl-icons';

interface EmailAddressFieldProps {
    label: string;
    value: string;
    showRequiredIndicator?: boolean;
    helperText?: string;
    onInfoClick?: () => void;
}

const EmailAddressField: React.FC<EmailAddressFieldProps> = ({ value, label }) => {
    return (
        <FormField label={label}>
            <Flex sx={{ inlineSize: '100%' }}>
                <Box sx={{ flexGrow: 1 }}>
                    <Text sx={{ fontFamily: 'default' /* Indeed Sans comes from IFL theme */ }}>
                        {value}
                    </Text>
                </Box>
                <ToggleTooltip label="こちらがご利用中のアカウントのメールアドレスです。変更するには、アカウント設定に移動してください。">
                    <InfoButton>
                        <Information aria-hidden sx={{ color: 'foreground.status.info' }} />
                    </InfoButton>
                </ToggleTooltip>
            </Flex>
        </FormField>
    );
};

export default EmailAddressField;
